export default __webpack_public_path__ + "static/media/trussardiWhite.301eb408.webp";